__turbopack_context__.v({
  "button": "AppShell-module__-0iDhq__button",
  "content": "AppShell-module__-0iDhq__content",
  "header": "AppShell-module__-0iDhq__header",
  "icon": "AppShell-module__-0iDhq__icon",
  "root": "AppShell-module__-0iDhq__root",
});
